import React, { useEffect, useState } from "react";

export interface IconMicProps
    extends Pick<React.SVGProps<SVGSVGElement>, "className" | "style" | "width" | "height"> {
    /** 0~1 */
    getVolumeLevel?: () => number;
    /** 0~1 */
    noise?: number;
    color?: string;
}

export const IconMic = React.memo<IconMicProps>(function IconMic({
    getVolumeLevel,
    noise = 0.075,
    color = "#AAAAAA",
    ...restProps
}) {
    noise = Math.max(0, Math.min(1, noise));

    const vHeight = 14;
    const vWidth = 8;
    const vBaseX = 8;
    const vBaseY = 1;

    const [baseVolumeLevel, setBaseVolumeLevel] = useState(0);
    const [volumeLevel, setVolumeLevel] = useState(0);

    useEffect(() => {
        if (!getVolumeLevel) {
            setBaseVolumeLevel(0);
            return;
        }

        const safeSetVolumeLevel = (): void => {
            setBaseVolumeLevel(Math.max(0, Math.min(1, getVolumeLevel())));
        };

        safeSetVolumeLevel();
        const ticket = setInterval(safeSetVolumeLevel, 500);

        return () => clearInterval(ticket);
    }, [getVolumeLevel]);

    React.useEffect(() => {
        if (!baseVolumeLevel) {
            return;
        }

        const ticket = setInterval(() => {
            setVolumeLevel(
                baseVolumeLevel + Math.random() * noise * (Math.random() > 0.5 ? 1 : -1),
            );
        }, 50);

        return () => clearInterval(ticket);
    }, [baseVolumeLevel, noise]);

    return (
        <svg
            fill="none"
            height="24"
            viewBox="0 0 24 24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
            {...restProps}
        >
            <defs>
                <clipPath id="icon-mic-v-clip">
                    <rect height={vHeight} rx={vWidth / 2} width={vWidth} x={vBaseX} y={vBaseY} />
                </clipPath>
            </defs>

            <path
                d="M19.1197 9.11986C18.7297 9.11986 18.4197 9.42986 18.4197 9.81986V11.3999C18.4197 14.9399 15.5397 17.8199 11.9997 17.8199C8.45969 17.8199 5.57969 14.9399 5.57969 11.3999V9.80986C5.57969 9.41986 5.26969 9.10986 4.87969 9.10986C4.48969 9.10986 4.17969 9.41986 4.17969 9.80986V11.3899C4.17969 15.4599 7.30969 18.8099 11.2997 19.1699V21.2999C11.2997 21.6899 11.6097 21.9999 11.9997 21.9999C12.3897 21.9999 12.6997 21.6899 12.6997 21.2999V19.1699C16.6797 18.8199 19.8197 15.4599 19.8197 11.3899V9.80986C19.8097 9.42986 19.4997 9.11986 19.1197 9.11986Z"
                fill={color}
            />
            <path
                d="M12.0001 2C9.56008 2 7.58008 3.98 7.58008 6.42V11.54C7.58008 13.98 9.56008 15.96 12.0001 15.96C14.4401 15.96 16.4201 13.98 16.4201 11.54V6.42C16.4201 3.98 14.4401 2 12.0001 2ZM13.3101 8.95C13.2401 9.21 13.0101 9.38 12.7501 9.38C12.7001 9.38 12.6501 9.37 12.6001 9.36C12.2101 9.25 11.8001 9.25 11.4101 9.36C11.0901 9.45 10.7801 9.26 10.7001 8.95C10.6101 8.64 10.8001 8.32 11.1101 8.24C11.7001 8.08 12.3201 8.08 12.9101 8.24C13.2101 8.32 13.3901 8.64 13.3101 8.95ZM13.8401 7.01C13.7501 7.25 13.5301 7.39 13.2901 7.39C13.2201 7.39 13.1601 7.38 13.0901 7.36C12.3901 7.1 11.6101 7.1 10.9101 7.36C10.6101 7.47 10.2701 7.31 10.1601 7.01C10.0501 6.71 10.2101 6.37 10.5101 6.27C11.4701 5.92 12.5301 5.92 13.4901 6.27C13.7901 6.38 13.9501 6.71 13.8401 7.01Z"
                fill={color}
            />

            <g clipPath="url(#icon-mic-v-clip)">
                <rect
                    fill="#44AD00"
                    height={vHeight * 2}
                    style={{
                        transform: `translateY(${(1 - volumeLevel) * vHeight}px)`,
                        transition: "transform .1s",
                    }}
                    width={vWidth}
                    x={vBaseX}
                    y={vBaseY}
                />
            </g>
        </svg>
    );
});
